// src/com/auto_plan/AutoPlanDict.js
import { InputType, TableColumnType } from "../../value/AppConst";
import IsValid from "../../value/IsValid";

// 상온 자동배차, auto_plan
const Dict = {
    // toAdd, toEdit : mark if need to submit for mutation
    /* arriveId : {
		id: 'arriveId', label: 'arriveId',
		type: InputType.text, required: true, toAdd: true, toEdit: true,
		help: '12자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 12)},
	}, // varchar(12)
    dcCd : {
		id: 'dcCd', label: 'dcCd',
		type: InputType.text, required: true, toAdd: true, toEdit: true,
		help: '3자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 3)},
	}, // varchar(3)
    planDate : {
		id: 'planDate', label: 'planDate',
		type: InputType.text, required: true, toAdd: true, toEdit: true,
	}, // date
    hocha : {
		id: 'hocha', label: 'hocha',
		type: InputType.number, required: true, toAdd: true, toEdit: true,
		check: (value) => {return value >= -999 && value <= 999},
	}, // int(11)
    storeId : {
		id: 'storeId', label: 'storeId',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '10자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 10)},
	}, // varchar(10)
    storeApplyCom : {
		id: 'storeApplyCom', label: '업체 ID',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '10자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 10)},
	}, // varchar(10) */
    vehTypeId : {
		id: 'vehTypeId', label: '차종',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
        labelKey: 'vehTypeName',
		check: (value) => {return IsValid.string(value, 0, 10)},
	}, // varchar(10)
    /* vehPtCapa : {
		id: 'vehPtCapa', label: 'vehPtCapa',
		type: InputType.number, required: true, toAdd: true, toEdit: true,
		check: (value) => {return value >= -999 && value <= 999},
	}, // int(11)
    nextDay : {
		id: 'nextDay', label: 'nextDay',
		type: InputType.checkbox, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= -999 && value <= 999},
	}, // tinyint(1) */
    shprTime : {
		id: 'shprTime', label: '접안시간',
		type: InputType.time, required: false, toAdd: true, toEdit: true,
	}, // time
    startTime : {
		id: 'startTime', label: '출발시간',
		type: InputType.time, required: false, toAdd: true, toEdit: true,
	}, // time
    arriveTime : {
		id: 'arriveTime', label: '도착시간',
		type: InputType.time, required: false, toAdd: true, toEdit: true,
	}, // time
    returnTime : {
		id: 'returnTime', label: '복귀시간',
		type: InputType.time, required: false, toAdd: true, toEdit: true,
	}, // time
    /* bindBool : {
		id: 'bindBool', label: '동적여부',
		type: InputType.checkbox, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= -999 && value <= 999},
	}, // tinyint(1)
    chargeGood : {
		id: 'chargeGood', label: '용차효율 좋음표시',
		type: InputType.checkbox, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= -999 && value <= 999},
	}, // tinyint(1)
    tsrPrinted : {
		id: 'tsrPrinted', label: 'tsrPrinted',
		type: InputType.checkbox, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= -999 && value <= 999},
	}, // tinyint(1)
    note : {
		id: 'note', label: 'note',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '300자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 300)},
	}, // varchar(300)
    regTypeCd : {
		id: 'regTypeCd', label: 'regTypeCd',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '1자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 1)},
	}, // enum('R','A','M')
    storeName : {
		id: 'storeName', label: 'storeName',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '30자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 30)},
	}, // varchar(30)
    basicExpectRunTime : {
		id: 'basicExpectRunTime', label: 'basicExpectRunTime',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '4자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 4)},
	}, // varchar(4)
    vehTypeAlias : {
		id: 'vehTypeAlias', label: 'vehTypeAlias',
		type: InputType.text, required: true, toAdd: true, toEdit: true,
		help: '10자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 10)},
	}, // varchar(10)
    planId : {
		id: 'planId', label: 'planId',
		type: InputType.text, required: true, toAdd: true, toEdit: true,
		help: '12자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 12)},
	}, // varchar(12)
    comId : {
		id: 'comId', label: 'comId',
		type: InputType.text, required: true, toAdd: true, toEdit: true,
		help: '10자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 10)},
	}, // varchar(10)
    vehPlates : {
		id: 'vehPlates', label: 'vehPlates',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '20자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 20)},
	}, // varchar(20) */
    
};

/**
 * AUTO_PLAN React Component Dictionary for Input and Output
 * Project: NewTOP for cloud
 * 2026-06-17 16:15:52 using DbdbTap
 * https://www.dbdbtap.com
 */
export const AutoPlanDictionary = {
    inputMap: Dict,
    errorTitle: {
        Add: '자동배차 등록 오류',
        Edit: '자동배차 수정 오류',
        Remove: '자동배차 삭제 오류',
        Get: '자동배차 조회 오류',
    },
};
